/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum FeeTypeEnum {
    NONE = 'None',
    PERCENTAGE = 'Percentage',
    FLAT = 'Flat',
}